import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import PropTypes from 'prop-types';
import Content from '../../../layout/Content';
import CabinCrewMovementHistoryForm from './CabinCrewMovementHistoryForm';
import { CABIN_CREW_MOVEMENT_HISTORY_PATH } from '../../../../config/paths';
import { breadcrumbPropType } from '../../../common/resource/proptypes/CommonPropTypes';
import { postCabinCrewMovementHistory } from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';

const NewCabinCrewMovementHistory = ({
  breadcrumbs,
  dispatchPostCabinCrewMovementHistory,
}) => {
  const onSubmit = (formValues) => {

    const { month, year, driverMovement } = formValues;

    const startDate = tzNormalizeDate({
      date: formValues.startDate,
    });

    const endDate = tzNormalizeDate({
      date: formValues.endDate,
    });

    if (moment(startDate).isAfter(moment(endDate))) {
      toastr.error(
        'Error',
        'La fecha de inicio no puede ser mayor a la fecha de fin',
      );
      return;
    }

    const newFormValues = {
      ...formValues,
      startDate,
      endDate,
    };

    const isVacation = !!driverMovement.vacation || !!driverMovement.paidVacation;

    if (driverMovement.maxDaysPerMonth) {
      newFormValues.chargeMonth = month.value;
      newFormValues.chargeYear = year;
    } else if (isVacation) {
      newFormValues.chargeMonth = null;
      newFormValues.chargeYear = formValues.vacationPeriod ? formValues.vacationPeriod.value : null;
    } else {
      newFormValues.chargeMonth = null;
      newFormValues.chargeYear = null;
    }

    dispatchPostCabinCrewMovementHistory(newFormValues);
  };

  const content = <CabinCrewMovementHistoryForm onSubmit={onSubmit} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo movimiento de tripulante"
      content={content}
    />
  );
};

NewCabinCrewMovementHistory.propTypes = {
  breadcrumbs: breadcrumbPropType.isRequired,
  dispatchPostCabinCrewMovementHistory: PropTypes.func.isRequired,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Movimientos de tripulante',
      href: CABIN_CREW_MOVEMENT_HISTORY_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostCabinCrewMovementHistory: postCabinCrewMovementHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewCabinCrewMovementHistory);